import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchMeeting } from "../../../actions/meetings.actions";
import SplitView from "../../../dumb-components/shared/layout/split-view/split-view";
import ScrollView from "../../../dumb-components/shared/layout/scroll-view/scroll-view";
import ProtocolTabsContainer from "../protocol/protocol-tabs.container";
import MeetingTasksListContainer from "./meetings-tasks-list.container";
import ProtocolToolbarContainer from "../meeting/smart-meeting/protocol-toolbar.container";
import MeetingsTasksDetailsWrapperContainer from "./meetings-tasks-details-wrapper.container";

import {
  calculateMaxWidthOfSplitView,
  toggleVisibilityOfTabs,
} from "../../../components/helpers/tabs.helper";

class MeetingTasksContainer extends Component {
  // References to the scrollviews
  scrollViewRefs = {};

  // Reference to the tabs
  tabsRef;

  // Timer
  resizeEnd;

  state = {
    hiddenTabs: [],
  };

  componentDidMount = () => {
    window.addEventListener("resize", this.onWindowResize, false);
    this.onWindowResize();
  };

  componentWillUnmount = () => {
    window.removeEventListener("resize", this.onWindowResize, false);
  };

  onWindowResize = () => {
    let { hiddenTabs } = this.state;
    const maxWidth = calculateMaxWidthOfSplitView(this.scrollViewRefs);
    hiddenTabs = toggleVisibilityOfTabs(this.tabsRef, hiddenTabs, { maxWidth });

    this.setState({ hiddenTabs });
  };

  getComponentBasePath = () => {
    const {
      location: { pathname },
    } = this.props;
    const path = pathname;
    const pathArray = path.split("tasks");
    return pathArray[0] + "tasks";
  };

  renderLeftHeader = () => {
    const { location } = this.props;
    const { hiddenTabs } = this.state;

    return (
      <ProtocolTabsContainer
        location={location}
        match="tasks"
        onSetRef={(ref) => (this.tabsRef = ref)}
        hiddenTabs={hiddenTabs}
      />
    );
  };

  renderLeftSplitView = () => {
    const basePath = this.getComponentBasePath();

    return (
      <ScrollView
        header={this.renderLeftHeader}
        headerBottomMargin={3}
        showOnHover={true}
        onSetRef={(ref) => (this.scrollViewRefs["left"] = ref)}
      >
        <MeetingTasksListContainer basePath={basePath} />
      </ScrollView>
    );
  };

  renderRightHeader = () => {
    const {
      location,
      match: { params },
    } = this.props;
    const basePath = this.getComponentBasePath();

    return (
      <ProtocolToolbarContainer
        location={location}
        params={params}
        basePath={basePath.split("/tasks")[0]}
      />
    );
  };

  renderRightSplitView = () => {
    const { match } = this.props;

    return (
      <ScrollView
        header={this.renderRightHeader}
        headerBottomMargin={3}
        showOnHover={true}
        onSetRef={(ref) => (this.scrollViewRefs["right"] = ref)}
      >
        {match.params.taskId && (
          <MeetingsTasksDetailsWrapperContainer
            match={match}
            location={this.props.location}
            history={this.props.history}
          />
        )}
      </ScrollView>
    );
  };

  render = () => {
    return (
      <SplitView
        leftComponent={this.renderLeftSplitView}
        rightComponent={this.renderRightSplitView}
      />
    );
  };
}

const mapStoreToProps = (store) => {
  return {
    meeting: store.meetings.get("meeting"),
  };
};

const mapActionsToProps = {
  fetchMeeting,
};

export default connect(
  mapStoreToProps,
  mapActionsToProps,
)(MeetingTasksContainer);
